import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import logoI from '../../pics/logo_I.png';
const SIZE_SPINNER_MAP = {
    sm: 'h-5 w-5 border-2',
    md: 'h-10 w-10 border-3',
    lg: 'h-16 w-16 border-4',
};
const SIZE_TEXT_MAP = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
};
const Loading = ({ size = 'md', text = 'Carregando...', fullScreen = false, className = '', ...rest }) => {
    if (fullScreen) {
        return (_jsx("div", { className: "fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-[#1a1a1a] to-[#020202] z-[9999] transition-all duration-300", ...rest, children: _jsxs("div", { className: "relative flex flex-col items-center", children: [_jsx("div", { className: "mb-8 relative", children: _jsx("img", { src: logoI, alt: "ICAVI", className: "h-16 w-auto animate-bounce-subtle drop-shadow-2xl" }) }), _jsxs("div", { className: "relative", children: [_jsx("div", { className: `animate-spin rounded-full border-white/15 border-t-icavi-500 ${SIZE_SPINNER_MAP['lg']}` }), _jsx("div", { className: `absolute inset-0 animate-ping rounded-full border-white/15 border-t-icavi-500 opacity-20 ${SIZE_SPINNER_MAP['lg']}` })] }), text && (_jsxs("div", { className: "mt-6 flex flex-col items-center gap-1", children: [_jsx("p", { className: "text-white font-bold text-xl tracking-wide animate-pulse drop-shadow-sm", children: text }), _jsx("p", { className: "text-white/80 text-sm font-light tracking-wider", children: "Aguarde um momento" })] }))] }) }));
    }
    // Inline/Block Loading (keeps default colors for white backgrounds)
    const containerClasses = ['flex flex-col items-center justify-center p-4', className]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: containerClasses, ...rest, children: [_jsx("div", { className: [
                    'animate-spin rounded-full border-gray-200 border-t-icavi-500 mb-3',
                    SIZE_SPINNER_MAP[size],
                ]
                    .filter(Boolean)
                    .join(' ') }), text && (_jsx("p", { className: ['text-gray-500 font-medium animate-pulse', SIZE_TEXT_MAP[size]].join(' '), children: text }))] }));
};
export default Loading;
